// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".income-summary-dropdown :deep(.buttons-wrapper){width:100%}.income-summary-dropdown .income-summary-toggle{width:201px}@media(max-width: 1199.98px){.income-summary-dropdown .income-summary-toggle{width:228px}}", ""]);
// Exports
module.exports = exports;
